export function isNumberHaveValue(number?: number | null): boolean {
  return number !== null && number !== undefined
}

export function isEmptyValue(value: any): boolean {
  return value === null || value === undefined || value === ''
}
